module.exports = __webpack_public_path__ + "img/stat1.bdb4fcc2.svg";